import React, { lazy, Suspense, useCallback } from 'react'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { useDispatch } from 'react-redux'
import { useObservableProperties } from '@core/Utils/hooks'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { setShouldHideBackButton } from '@core/Areas/AppHeader/Store'

const App = lazy(() => import('@mobi/account/Areas/PersonalDetails/Components/App'))

export const PersonalDetails = (): JSX.Element | null => {
  const dispatch = useDispatch()
  const { accountNumber } = useObservableProperties(userAccountState$, ['accountNumber'], {
    accountNumber: null,
  })

  const onOtpFlowActiveChange = useCallback(
    (isOtpFlowActive: boolean) => dispatch(setShouldHideBackButton(isOtpFlowActive)),
    [dispatch],
  )

  // This page cannot be loaded if the user isn't logged in anyway
  if (accountNumber === null) return <Spinner />

  return (
    <Suspense fallback={<Spinner />}>
      <App
        betAccountNumber={accountNumber}
        appVersion={fullClientVersion}
        onOtpFlowActiveChange={onOtpFlowActiveChange}
      />
    </Suspense>
  )
}
